import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useState
} from "react";

type OverlayContext = {
  overlayOpened: boolean;
  setOverlayOpened: (open: boolean) => void;
  flyoutOpened: boolean;
  registerFlyoutOpened: () => void;
  registerFlyoutClosed: () => void;
  searchOpened: boolean;
  setSearchOpened: (open: boolean) => void;
};

export const overlayContext = createContext<OverlayContext>(
  {} as OverlayContext
);

export const OverlayContextProvider = ({
  children
}: {
  children: ReactNode;
}) => {
  const [overlayOpened, setOverlayOpened] = useState(false);
  const [flyoutOpened, setFlyoutOpened] = useState(false);
  const [searchOpened, setSearchOpened] = useState(false);

  //If one flyout is closing at the same time as another is opening, make sure the opening is registered last:
  const registerFlyoutOpened = useCallback(() => {
    setTimeout(() => setFlyoutOpened(true), 1);
  }, []);
  const registerFlyoutClosed = useCallback(() => {
    setFlyoutOpened(false);
  }, []);

  return (
    <overlayContext.Provider
      value={{
        overlayOpened,
        setOverlayOpened,
        flyoutOpened,
        registerFlyoutOpened,
        registerFlyoutClosed,
        searchOpened,
        setSearchOpened
      }}
    >
      {children}
    </overlayContext.Provider>
  );
};

export const useOverlayContext = () => useContext(overlayContext);
